import Toggle from "components/ui/toggle";
import { Color } from "utils/theme";

interface GuidanceModeCardProps {
  title: string;
  description: string;
  enabled: boolean;
  onToggle: (value: boolean) => void;
  featureFlag: boolean;
}

export const GuidanceModeCard = ({
  title,
  description,
  enabled,
  onToggle,
  featureFlag,
}: GuidanceModeCardProps) => {
  return (
    <div
      className="flex flex-col gap-y-4 sm:flex-row items-start justify-between mb-4 border p-4 xl:p-6 rounded-lg cursor-pointer overflow-hidden"
      style={{
        borderColor: Color.Primary[700],
        backgroundColor: Color.Primary[800],
        opacity: featureFlag ? 0.6 : 1,
      }}
      data-analytics={`guidance-mode.${title}`}
      onClick={() => !featureFlag && onToggle(!enabled)}
      onPointerDown={(e) => {
        if (featureFlag) return;
        e.currentTarget.style.opacity = "0.8";
      }}
      onPointerUp={(e) => {
        if (featureFlag) return;
        e.currentTarget.style.opacity = "1";
      }}
      onPointerLeave={(e) => {
        if (featureFlag) return;
        e.currentTarget.style.opacity = "1";
      }}
      onPointerEnter={(e) => {
        if (featureFlag) return;
        e.currentTarget.style.opacity = "0.8";
      }}
    >
      <div className="mr-10">
        <div className="flex items-center mb-2">
          <p className="text-xl xl:text-2xl font-medium tracking-wide">
            {title}
          </p>
        </div>
        <p
          className="text-base xl:text-lg"
          style={{ color: Color.Primary[400] }}
        >
          {featureFlag ? "Feature not available." : description}
        </p>
      </div>
      <div onClick={(e) => e.stopPropagation()}>
        <Toggle
          enabled={enabled}
          setEnabled={onToggle}
          disabled={featureFlag}
          name={`guidance-mode.${title}`}
        />
      </div>
    </div>
  );
};
